import { render, staticRenderFns } from "./CouponGroup.vue?vue&type=template&id=55fa8acc"
import script from "./CouponGroup.vue?vue&type=script&lang=js"
export * from "./CouponGroup.vue?vue&type=script&lang=js"
import style0 from "./CouponGroup.vue?vue&type=style&index=0&id=55fa8acc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports